/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PushTokenUpsertForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DeletePushTokenCittadinoRequestParams {
    idDevice: string;
}

export interface UpsertPushTokenCittadinoRequestParams {
    pushTokenUpsertForm: PushTokenUpsertForm;
}


export interface CittadinoPushTokenServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Rimuove il push token del cittadino per un dispositivo.
     * Rimuove il push token del caller per il device indicato. Scopata sul caller: un id_device altrui non è raggiungibile (no-op).
     * @endpoint delete /api/v1/cittadino/push-token
* @param requestParameters
     */
    deletePushTokenCittadino(requestParameters: DeletePushTokenCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Registra o aggiorna il push token del cittadino.
     * Upsert idempotente del push token Firebase per il dispositivo indicato. Lo user è sempre il caller. Il token è validato via Firebase: se non valido → 400.
     * @endpoint put /api/v1/cittadino/push-token
* @param requestParameters
     */
    upsertPushTokenCittadino(requestParameters: UpsertPushTokenCittadinoRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
